import React, { useCallback, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AccordionSummary } from "@mui/material";

import { image } from "src/theme";
import { CommonDescTwo } from "@assets/styles/CommonStyles";
import { ListWithTabs } from "@components/list";
import { DangerouslyHtml, MuiPagination } from "@components/item";
import {
  CustomerCenterArrow,
  CustomerCenterLeft,
  CustomerCenterListAccordion,
  CustomerCenterListAccordionHeader,
  CustomerCenterListCounter,
  CustomerCenterTitle,
  NoticeListAccordionDetails,
  NoResultFoundWrapper,
} from "@pages/about-us/AboutUsStyling";
import { ErrorManage } from "@screens/index";
import { concatAllValue } from "@utils/modify-data/modifyData";
import {
  useGetAboutUsNoticeCategory,
  useGetAboutUsNoticeList,
} from "@utils/api-requests/AboutUsRequests";
import { NoResultFoundText } from "@utils/lanugauge-settings/static-texts/TranslatedTexts";
import { Search } from "@components/search";

const NoticeList = () => {
  const list = useRef();

  const location = useLocation();

  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [keyword, setKeyword] = useState("");

  const [filterType, setFilterType] = useState("all");
  const [expanded, setExpanded] = useState(false);

  const queryParams = new URLSearchParams(location.search);

  // Access query parameters
  const paramValue = queryParams.get("filter");

  const {
    data: aboutUsNoticeList,
    isFetching,
    isError,
    error,
  } = useGetAboutUsNoticeList(filterType, page, keyword);

  const { data: aboutUsNoticeCategory } = useGetAboutUsNoticeCategory();

  const noticeCategories = useMemo(() => {
    return aboutUsNoticeCategory?.map((item) => {
      paramValue === item.tid && setFilterType(item.tid);
      return {
        title: item.name,
        category_id: item.tid,
      };
    });
  }, [aboutUsNoticeCategory, paramValue]);

  const handleChange = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const tabChange = useCallback(() => {
    setExpanded(false);
    setPage(1);
  }, []);

  return (
    <>
      <Search
        keyword={keyword}
        setKeyword={setKeyword}
        setPage={setPage}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
      />

      <ErrorManage isFetching={isFetching} isError={isError} error={error}>
        <div ref={list}>
          <ListWithTabs
            tabArr={concatAllValue(noticeCategories)}
            filterType={filterType}
            setFilterType={setFilterType}
            changeEvent={tabChange}
          >
            {aboutUsNoticeList?.length <= 0 ? (
              <NoResultFoundWrapper>
                <NoResultFoundText />
              </NoResultFoundWrapper>
            ) : (
              aboutUsNoticeList?.map((item, idx) => {
                return (
                  <CustomerCenterListAccordion
                    square
                    key={item.field_customer_center_title}
                    expanded={expanded === item.field_customer_center_title}
                    onChange={handleChange(item.field_customer_center_title)}
                  >
                    <AccordionSummary
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                    >
                      <CustomerCenterListAccordionHeader>
                        <CustomerCenterLeft>
                          <CustomerCenterListCounter
                            expanded={
                              expanded === item.field_customer_center_title
                            }
                          >
                            {(page - 1) * 10 + (idx + 1)}
                          </CustomerCenterListCounter>

                          <CustomerCenterTitle>
                            <span>{item.field_customer_center_category}</span>

                            <CommonDescTwo>
                              <DangerouslyHtml
                                className="ellipsis-1"
                                value={item.field_customer_center_title}
                              />
                            </CommonDescTwo>
                          </CustomerCenterTitle>
                        </CustomerCenterLeft>

                        <CustomerCenterArrow
                          expanded={
                            expanded === item.field_customer_center_title
                          }
                          src={image.faqAngleDown.default}
                          alt="down arrow"
                          height={12}
                        />
                      </CustomerCenterListAccordionHeader>
                    </AccordionSummary>

                    <NoticeListAccordionDetails>
                      <DangerouslyHtml
                        value={item.field_customer_center_contents}
                      />
                    </NoticeListAccordionDetails>
                  </CustomerCenterListAccordion>
                );
              })
            )}
          </ListWithTabs>
        </div>

        {aboutUsNoticeList?.length > 0 && (
          <MuiPagination
            listRef={list}
            count={aboutUsNoticeList?.[0]?.pager?.total_pages}
            defaultPage={1}
            page={page}
            setPage={setPage}
          />
        )}
      </ErrorManage>
    </>
  );
};

export default NoticeList;
